import { env } from '../../../../env';
import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import retrievePasswordMessages from '../../../../messages/user-access/retrievePassword.messages';
import { ErrorMessages } from '../../../../model/error';
import { RetrievePasswordError } from './retrieve-password-types';

export const messagesForRetrievePasswordError = (
  error: RetrievePasswordError
): ErrorMessages => {
  switch (error) {
    case 'USERNAME_REQUIRED':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorFieldsNotFill,
      };
    case 'NOT_MIGRATED_USER':
      return {
        title:
          env.appModule === 'web'
            ? commonErrorMessages.errorNotMigratedUserWeb
            : {...commonErrorMessages.errorNotMigratedUserMobile,
              defaultMessage: commonErrorMessages.errorNotMigratedUserMobile.defaultMessage.replace('{url}', env.oldMyAzimutUrl)
            }
      };
    case 'INVALID_USER_CODE':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorInvalidUsername,
      };
    case 'TOO_MANY_REQUESTS':
      return { title: retrievePasswordMessages.errorTooManyRequests };
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};
